const FIRMA_CONTRIBUYENTE = 'Firma del contribuyente'
const IDENTIFICACION_CONTRIBUYENTE = '[[FECHA_FIRMA]] - [[SOLICITANTE_NOMBRE]] - [[SOLICITANTE_TIPO_DOCUMENTO]] [[SOLICITANTE_NUMERO_DOCUMENTO]] - Domicilio: [[SOLICITANTE_DOMICILIO]] - [[SOLICITANTE_LOCALIDAD]]'
const CAMPOS_CONTACTO = ['firma:', 'dni:', 'mail:', 'teléfono:']
const CAMPO = /^([^_]+?:)\s*_{3,}$/
const LINEA = /^_{3,}$/

// Las columnas que equivalen a las firmas de antes, al pasarlas a dos columnas. Reconoce los mismos
// formatos que el convenio impreso (getFirmasConvenio, en plan-pago-convenio-detalle/presentacion.ts
// del webapi): la plantilla de identificación del solicitante y el formulario de contacto + autoridad.
// Un texto que no se reconoce va entero a la columna izquierda.
export const getColumnasEquivalentes = (firmas) => {
    if (!/<[a-z][^>]*>/i.test(firmas)) {
        if (firmas.replace(/\s+/g, ' ').trim() === IDENTIFICACION_CONTRIBUYENTE) {
            return { firmasIzquierda: `${FIRMA_CONTRIBUYENTE}\n${firmas.trim()}`, firmasDerecha: '' }
        }
        const autoridad = getAutoridadContacto(firmas)
        if (autoridad) {
            return { firmasIzquierda: FIRMA_CONTRIBUYENTE, firmasDerecha: autoridad.join('\n') }
        }
    }
    return { firmasIzquierda: firmas, firmasDerecha: '' }
}

// Los renglones de la autoridad del formulario de contacto: un bloque con los campos Firma, DNI, Mail
// y Teléfono, y otro con una línea y los renglones de la autoridad, separados por dos líneas vacías o más.
const getAutoridadContacto = (firmas) => {
    const bloques = firmas.trim().split(/\r?\n(?:[\t ]*\r?\n){2,}/)
        .map(bloque => bloque.split(/\r?\n/).map(linea => linea.trim()).filter(Boolean))
        .filter(bloque => bloque.length > 0)
    if (bloques.length !== 2) return null
    const [contacto, autoridad] = bloques
    const esContacto = contacto.length === CAMPOS_CONTACTO.length &&
        contacto.every((linea, i) => (CAMPO.exec(linea)?.[1] ?? '').toLowerCase() === CAMPOS_CONTACTO[i])
    const esAutoridad = autoridad.length > 1 && LINEA.test(autoridad[0]) &&
        autoridad.slice(1).every(linea => !CAMPO.test(linea) && !LINEA.test(linea))
    return esContacto && esAutoridad ? autoridad.slice(1) : null
}
